import React, {PureComponent} from 'react';
import {Link} from 'react-router-dom';
import dayjs from 'dayjs';

import ActivityIcon from 'react-feather/dist/icons/activity'
import {Row, Col, Icon} from 'antd';
import {MapMarkerIcon} from '../Icons'
import style from './BoardItem.css';
import colors from '../colors';
import IconBadge from "./IconBadge";


export default class LiveItem extends PureComponent {
  render() {
    let {live} = this.props;
    let {last, location} = live;

    return (
      <div className={style.board}>
        <div className={'d-flex'}>
          <div className={style.live_content}>
            {/*<div className="d-flex">*/}
            {/*  <span>🔥</span>*/}
            {/*  <Icon type="search" style={{color: 'red'}}/>*/}
            {/*  &nbsp;*/}
            {/*  <Icon type="weibo" style={{color: 'red'}}/>*/}
            {/*  &nbsp;*/}
            {/*  <Icon type="wechat" style={{color: 'red'}}/>*/}
            {/*  &nbsp;*/}
            {/*  <Icon type="zhihu" style={{color: 'red'}}/>*/}
            {/*</div>*/}

            {location ? <div className={style.live_location}>
              <MapMarkerIcon size={16} fill={colors.accentColor}/> &nbsp;{location.name}, {location.city}
            </div> : null}

            <Link to={'/lives/' + live.id}>
              <h4 className={style.live_title}>{live.title}</h4>
            </Link>

            <p className={style.live_summary}>{(live.summary || '').substr(0, 200)}</p>

            <div className={style.one_line}>
              <IconBadge icon={<ActivityIcon/>} text={live.threads_count}/>
              &nbsp;
              {/*<IconBadge icon={'😂'} text={'+' + live.threads_count}/>*/}

              {last ?
                <div className={style.live_thread}>
                  {/*<div className="activity-count">*/}
                  {/*  <Activity/>*/}
                  {/*  <span class="float-right"> {live.threads_count} </span>*/}
                  {/*</div>*/}

                  <Link to={"/lives/" + live.id}>
                    <time>{dayjs(last.link.publish_at).fromNow()}</time>
                    &nbsp;
                    ·
                    &nbsp;
                    {last.link.title}
                  </Link>
                </div>
                : null}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
